import { render, staticRenderFns } from "./groupSort.vue?vue&type=template&id=72c152df&scoped=true"
import script from "./groupSort.vue?vue&type=script&lang=js"
export * from "./groupSort.vue?vue&type=script&lang=js"
import style0 from "./groupSort.vue?vue&type=style&index=0&id=72c152df&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c152df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72c152df')) {
      api.createRecord('72c152df', component.options)
    } else {
      api.reload('72c152df', component.options)
    }
    module.hot.accept("./groupSort.vue?vue&type=template&id=72c152df&scoped=true", function () {
      api.rerender('72c152df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/menuTemplateManage/groupSort.vue"
export default component.exports